module.exports = __webpack_public_path__ + "img/skating_2018_003.5d1890ce.jpg";